const mobileElements = {
  mobileMenu: document.querySelector('.mobile-menu'),
  mobileMenuTrigger: document.querySelector('.header__menuIcon'),
  overlayTrigger: document.querySelector('.overlay--body'),
  body: document.querySelector('body'),
  header: document.querySelector('.header'),
  items: document.querySelectorAll('.menu-item'),
};

const { mobileMenuTrigger, overlayTrigger, mobileMenu, body, header, items } =
  mobileElements;

// const animateItems = () => {

//   let interval = 50;

//   items.forEach((i, index) => {
//     // i.addEventListener('click' , () => {
//     //   toggleMenu();
//     // });
//     if (!i.classList.contains('reveal')) {
//       setTimeout(function () {
//         i.classList.toggle('reveal');
//       }, index * interval);
//     } else {
//       i.classList.toggle('reveal');
//     }
//   });

// }

const navToggle = '<span class="mobile-menu__sub-menu-toggle"></span>';

function manipulateMenu() {
  Array.prototype.forEach.call(
    document.querySelectorAll('.menu-item-has-children'),
    function (trigger) {
      trigger.firstElementChild.insertAdjacentHTML('afterend', navToggle);
    }
  );
}

function toggleMenu() {
  mobileMenu.classList.toggle('mobile-menu--active');
  mobileMenuTrigger.classList.toggle('header__menuIcon--opened');
  body.classList.toggle('stopScroll');
  header.classList.toggle('header--menuOpen');

  // animateItems();
}

function MobileMenu() {
  manipulateMenu();

  mobileMenuTrigger.addEventListener('click', () => toggleMenu());
  overlayTrigger.addEventListener('click', () => toggleMenu());

  $('.mobile-menu__sub-menu-toggle').click(function () {
    $(this).toggleClass('mobile-menu__sub-menu-toggle--active');
    $(this).closest('.menu-item').find('.sub-menu').slideToggle();
  });
}

export default MobileMenu;
